import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AccountUserService } from '../service/account.service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  userIP: string;
  form: FormGroup;
  loading = false;
  submitted = false;
  returnUrl = "";
  interval;
  assestBaseUrl: string = environment.assestsBasePath;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private accountService: AccountUserService,
    private messageService: MessageService) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      organizationCode: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
    });

    this.route.queryParams
      .subscribe(params => this.returnUrl = params['return'] || '/');

    this.accountService.getIPAddress().subscribe((res: any) => {
      this.userIP = res && res.ip ? res.ip : '142.250.217.100';
    });
  }


  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    let randomstr = this.getRandomString(5);
    localStorage.setItem("randomstr", randomstr);

    let userDetail = {
      emailId: this.f.email.value.toLowerCase(),
      orgCode: this.f.organizationCode.value
    }

    // let userDetail = {
    //   "email": this.f.email.value.toLowerCase(),
    //   "userSource": this.userIP,
    //   "sourceType": "Web",
    //   "sessionId": randomstr,
    //   userIP: this.userIP,
    //   orgCode: this.f.organizationCode.value
    // }

    this.accountService.forgotPassword(userDetail).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'A password reset link has been sent to your email address' });
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Organization Code or Email. Please verify your details and try again.' });
      }
    });
  }

  showError(msg) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
  }

  getRandomString(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

}
